import { Text } from '@weareconceptstudio/core';

//* Styles
import TrusteeItemStyle from './style';

//* Components
import Image from '@/components/Image';

const TrusteeItem = ({ name, photo, position, title, className = '' }) => {
	return (
		<TrusteeItemStyle className={`trustee-item ${className}`}>
			<div className={'truster-wrapper'}>
				<Image
					src={photo?.src}
					alt={photo?.alt}
					className={'trustee-img'}
				/>

				<div className={'text-wrapper'}>
					<div className={'inner-text-wrapper'}>
						<Text className='h6 black-900 montserrat-400 trustee-name'>{name}</Text>

						<Text className='p1 black-900 montserrat-400 trustee-position'>{position}</Text>
					</div>

					<Text className='p2 black-900 montserrat-400'>{title}</Text>
				</div>
			</div>
		</TrusteeItemStyle>
	);
};

export default TrusteeItem;
